import {Component, OnInit}     from '@angular/core';
import {MatDialog}             from '@angular/material/dialog';
import {MatSnackBar}           from '@angular/material/snack-bar';
import {FormCategoryService}   from '../../services/form-category.service';
import {FormCategory}          from '../../models/form-category.model';
import {DialogComponent}       from '@src/app/shared/components/dialog/dialog.component';
import {FormCategoryFormComponent} from './form-category-form.component';

@Component({
    standalone: false,
    selector: 'app-form-categories',
    templateUrl: './form-categories.component.html',
    styleUrls: ['./form-categories.component.scss']
})
export class FormCategoriesComponent implements OnInit
{
    public displayedColumns: string[] = ['name', 'kind', 'type', 'sort_order', 'actions'];
    public categories: FormCategory[] = [];
    public isLoading = false;

    public constructor(
        private formCategoryService: FormCategoryService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
    )
    {
    }

    public ngOnInit(): void
    {
        this.loadCategories();
    }

    public loadCategories(): void
    {
        this.isLoading = true;
        this.formCategoryService.list().subscribe({
            next: response => {
                this.categories = response?.data ?? [];
                this.isLoading = false;
            },
            error: () => {
                this.isLoading = false;
                this.snackBar.open('Failed to load form categories.', 'Ok', {duration: 3500});
            }
        });
    }

    public openDialog(category: FormCategory | null = null): void
    {
        const dialogRef = this.dialog.open(FormCategoryFormComponent, {
            width: '40%',
            panelClass: 'mobile-width',
            disableClose: true,
            data: {category},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadCategories();
                this.snackBar.open(category ? 'Category updated.' : 'Category created.', 'Ok', {duration: 2500});
            }
        });
    }

    public confirmDelete(category: FormCategory): void
    {
        const confirmDialogRef = this.dialog.open(DialogComponent, {
            data: {
                title: 'Delete Category',
                message: `Are you sure you want to delete "${category.name}"? Categories in use by forms cannot be deleted.`,
                type: 'danger-outline',
                confirmButtonLabel: 'Delete'
            }
        });

        confirmDialogRef.afterClosed().subscribe(confirm => {
            if (confirm) {
                this.formCategoryService.delete(category.id).subscribe({
                    next: () => {
                        this.loadCategories();
                        this.snackBar.open('Category deleted.', 'Ok', {duration: 2500});
                    },
                    error: response => {
                        const message = response?.error?.message ?? 'Failed to delete category.';
                        this.snackBar.open(message, 'Ok', {duration: 4000});
                    }
                });
            }
        });
    }
}
